<script lang="ts">
	import { getClient, query } from 'svelte-apollo';
	import { onMount } from 'svelte';
	import { Icon } from '@smui/fab/styled';
	import { numToRedGreen } from '../../utils';
	import {
		csvStringToArrays,
		roundCellNumber,
		getValuesTest,
		getOtherTest
	} from './interestsTableUtils';
	import SmuiButton, { Label as SmuiLabel } from '@smui/button/styled';
	import AppContainer from '../../components/AppContainer.svelte';
	import LoadingOverlay from '../../components/LoadingOverlay.svelte';
	import GraphErrorList from '../../components/GraphQL/GraphErrorList.svelte';
	import { getFileContentQuery } from '../../graphql/queries/interests';
	import type { InterestSimpleObject } from 'Segments';

	let loading = false;
	let table: string[];
	let repeat = false;
	let errorList: string[];

	let output: InterestSimpleObject[][] = [];
	let all = [];
	let chosen = 1;
	let max = 10;

	function styleValueCell(cellValue: InterestSimpleObject) {
		let color: string;
		const valueIndex = all.indexOf(cellValue.value);
		if (valueIndex >= 0) {
			color = numToRedGreen((valueIndex * 10) / all.length / 10, 0.55);
		}
		return `background-color: ${color}`;
	}

	const client = getClient();
	const getFileContentOp = query(client, { query: getFileContentQuery });

	function parseCsvString(csvString: string) {
		table = csvStringToArrays(csvString);
		if (table[0].length == 1) {
			table = [];
		}
		output = getValuesTest(table);
		output
			.slice(1)
			.forEach((element) =>
				element.forEach((elementIndex: InterestSimpleObject) => all.push(elementIndex.value))
			);
		all.sort(function (a, b) {
			return a - b;
		});
	}

	const getFileFetch = async () => {
		loading = true;
		errorList = undefined;
		try {
			const { data } = await getFileContentOp.refetch();

			parseCsvString(data.getPersonaInterest);
		} catch (error) {
			errorList = error.graphQLErrors;
		}

		loading = false;
	};

	function handleClick(index: number) {
		if (index + 1 === chosen) {
			repeat = !repeat;
			output.splice(1).forEach((el, i) => {
				output[i + 1] = el.reverse();
			});
		} else {
			if (repeat) {
				output.splice(1).forEach((el, i) => {
					output[i + 1] = el.reverse();
				});
			}
			repeat = false;
			chosen = index + 1;
		}
	}

	onMount(() => {
		getFileFetch();
	});

	function MoreClick() {
		max += 5;
	}
</script>

<AppContainer style="position:relative;" fluid>
	{#if loading}
		<LoadingOverlay title="Loading..." spinner />
	{:else if table}
		<table>
			<tr>
				<th> Interests </th>
				{#each output[0] as colName, index}
					<th class="th-top">
						<button
							class="button-top"
							class:button-selected={index === chosen - 1}
							on:click={() => handleClick(index)}
						>
							{colName}
							{#if index === chosen - 1}
								{#if repeat}
									<Icon class="material-icons"><p class="myicon">arrow_drop_up</p></Icon>
								{:else}
									<Icon class="material-icons"><p class="myicon">arrow_drop_down</p></Icon>
								{/if}
							{/if}
						</button>
					</th>
				{/each}
			</tr>
			{#each output[chosen].slice(0, max) as cell}
				<tr>
					<td>
						{cell.name}
					</td>
					{#each getOtherTest(output, cell) as val}
						<td style={styleValueCell(val)}>
							{roundCellNumber(val.value)}
						</td>
					{/each}
				</tr>
			{/each}
			<tr>
				<div class="more-button">
					<SmuiButton on:click={MoreClick} variant="raised">
						<SmuiLabel>More</SmuiLabel>
					</SmuiButton>
				</div>
			</tr>
		</table>
	{:else}
		<center>
			This function is not yet enabled for you, if you want to use it, please contact
			<a href="mailto:gabriela.dvorakova@datasentics.com"> gabriela.dvorakova@datasentics.com </a>
		</center>
	{/if}
	<GraphErrorList {errorList}>
		<p>Data not available for client</p>
	</GraphErrorList>
</AppContainer>

<style>
	table {
		border-spacing: 0;
	}

	th {
		height: 140px;
		vertical-align: bottom;
		text-align: left;
		line-height: 1;
	}
	td {
		border-bottom: 1px solid #999;
		border-right: 1px solid hsla(0, 0%, 100%, 0.67);
		min-width: 40px;
	}

	td:first-of-type,
	th:first-of-type {
		min-width: 180px;
		width: 180px;
		padding-left: 8px;
		line-height: 1;
	}
	td:nth-of-type(n + 2) {
		text-align: right;
		padding: 11px 6px;
	}
	.th-top {
		min-width: 200px;
		height: 50px;
	}
	.button-top {
		border: 0;
		height: 100%;
		width: 100%;
	}
	.button-top:not(.button-selected):hover {
		background-color: #cbcfd7;
	}
	.button-selected {
		background-color: var(--mdc-theme-primary);
		color: white;
	}
	.myicon {
		position: absolute;
		padding-left: 8px;
		font-size: 35px;
		margin-top: -22px;
	}
	.more-button {
		padding-top: 20px;
		display: flex;
		align-items: center;
	}
</style>
